import { FormControl } from "@mui/material";
import React from "react";
import { Animation } from "../../../../TypesAndConstants/types";

export function AnimationDropdown(
  setAnimationMode: (e: React.ChangeEvent<HTMLSelectElement>) => void
) {
  return (
    <FormControl
      variant="outlined"
      style={{ minWidth: "120px", margin: "4px" }}
    >
      <label style={{ padding: "2px" }}>
        <h4
          style={{
            display: "inline",
            marginRight: "4px",
          }}
        >
          Animation:
        </h4>
        <select
          onChange={setAnimationMode}
          style={{ float: "right", marginRight: "15px", fontSize: "1.5rem" }}
        >
          <option value={Animation.None}>None</option>
          <option value={Animation.Wavey_Size}>Wavey Size</option>
          <option value={Animation.Wavey_Rotate}>Wavey Rotate</option>
          <option value={Animation.Rotate}>Rotate</option>
          <option value={Animation.Scatter}>Scatter</option>
        </select>
      </label>
    </FormControl>
  );
}
